import { paramsHook } from 'external/deep-diff'
import { isUUID, partition } from 'external/lodash'

import { packageService } from 'services/package.service'
import { userService } from 'services/user.service'
import { purchaseService } from 'services/purchase.service'
import { isLoggedInAndInRoute } from 'utilities/navigate'

export const fetchStudents = fetchUsers('Student')
export const fetchTutors = fetchUsers('Tutor')

const hooks =  [
  {paths: paramsHook('pageName'), resolves: fetchPackages},
  {paths: [...paramsHook('packageId'), 'packageRefreshes/'], resolves: fetchPackage},
  {paths: ['modals/selectStudent/open'], resolves: fetchStudents},
  {paths: ['modals/selectTutor/open'], resolves: fetchTutors}
]

export {hooks as default}

export async function fetchPackages({update, state}, {contexts}) {
    const id = isLoggedInAndInRoute('packages', {state, contexts})
    if (!id) return
    update({ packages: {$startLoading: {}}})
		const packages = await packageService.getPackageByClientId(id);
    update({ packages: {$updateLoadableList: packages.data.data}})
}

function fetchUsers (role) {
    const modalName = `select${role}`
    return async ({update, state}, {contexts}) => {
        const id = isLoggedInAndInRoute(['packages', 'package'], {state, contexts})
        if (!id) return
        if (!state.modals[modalName].open) return
        update({modals: {[modalName]: {$shallow: { loading: true, users: [] }}}})
        const students = await userService.getUsersByRole(role, id)
        update({modals: {[modalName]: {$shallow: { loading: false, users: students.data.data }}}})
    }
}

export async function fetchPackage({update, state}, {contexts}) {
  const id = isLoggedInAndInRoute('package', {state, contexts})
  if (!id) return
  const {props: {params: {packageId}}} = state
  if (!isUUID(packageId)) return
  update({packageItem: {$shallow: {loading: true, id: null, users: {}, courses: []}}})
  const [coursesResponse, usersResponse] = await Promise.all([
    purchaseService.getPurchaseCourses(packageId),
    purchaseService.getPurchaseItemUsers(packageId)
  ])
  const [ courses ] = coursesResponse.data.data || []
  const [ data ] = usersResponse.data.data || []
  const [elective, basic] = partition(courses, ({id}) => /^C7/.test(id))
  update({packageItem: {$shallow: {loading: false, id: packageId, data, courses: {basic, elective}}}})
}